<template>
  <section id="profile" ref="root" class="section">
    <div class="section-inner">
      <header v-reveal class="profile-head">
        <span class="eyebrow">05 — perfil</span>
        <h2 class="section-title">Como eu trabalho</h2>
        <p class="section-lead">
          Resultado da minha análise comportamental DISC e das âncoras que
          orientam minhas escolhas de carreira — porque tech também é sobre
          pessoas.
        </p>
      </header>

      <div class="profile-grid">
        <div v-reveal class="panel">
          <h3 class="column-title mono">perfil disc</h3>

          <div v-for="trait in disc" :key="trait.name" class="trait">
            <div class="trait-top">
              <span class="trait-name">{{ trait.name }}</span>
              <span class="trait-value mono">{{ trait.value }}%</span>
            </div>

            <div class="bar">
              <span
                class="bar-fill"
                :class="{ 'bar-fill--lead': trait.value === maxDisc }"
                :style="barStyle(trait.value)"
              ></span>
            </div>

            <p class="trait-traits">{{ trait.traits }}</p>
          </div>
        </div>

        <div v-reveal="90" class="panel">
          <h3 class="column-title mono">âncoras de carreira</h3>

          <div v-for="anchor in anchors" :key="anchor.name" class="anchor">
            <div class="trait-top">
              <span class="anchor-name">{{ anchor.name }}</span>
              <span class="trait-value mono">{{ anchor.value }}%</span>
            </div>

            <div class="bar bar--thin">
              <span
                class="bar-fill bar-fill--ai"
                :style="barStyle(anchor.value)"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProfilePage",

  data() {
    return {
      animated: false,
      observer: null,

      disc: [
        {
          name: "Dominante",
          value: 44,
          traits: "Resultados · Agilidade · Disciplina · Controle",
        },
        {
          name: "Analítico",
          value: 28,
          traits: "Garantir a execução · Cortar burocracia · Motivação",
        },
        {
          name: "Estável",
          value: 20,
          traits: "Autonomia nas atividades · Resolver problemas do seu jeito",
        },
        {
          name: "Influente",
          value: 8,
          traits: "Senso de urgência · Ação e iniciativa",
        },
      ],

      anchors: [
        { name: "Segurança e estabilidade", value: 93 },
        { name: "Autonomia e independência", value: 83 },
        { name: "Dedicação a uma causa", value: 73 },
        { name: "Competência em gestão", value: 70 },
        { name: "Criatividade empreendedora", value: 63 },
        { name: "Competência técnica / funcional", value: 63 },
        { name: "Estilo de vida", value: 60 },
        { name: "Desafio puro", value: 43 },
      ],
    };
  },

  computed: {
    maxDisc() {
      return Math.max(...this.disc.map((trait) => trait.value));
    },
  },

  methods: {
    barStyle(value) {
      return { width: this.animated ? `${value}%` : "0%" };
    },
  },

  mounted() {
    if (typeof IntersectionObserver === "undefined") {
      this.animated = true;
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.animated = true;
        this.observer.disconnect();
      },
      { threshold: 0.2 }
    );

    this.observer.observe(this.$refs.root);
  },

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
